export default __webpack_public_path__ + "media/images/theme/wordmark_dark-f48ea777082a79810bba2d04b21f745f.png";